module.exports = __webpack_public_path__ + "static/media/equipaje.747ce8fe.svg";